import {
  jb_teaser_header_css_default
} from "./chunk.SNWK3GRP.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-teaser-header/jb-teaser-header.ts
var JbTeaserHeader = class extends r {
  constructor() {
    super(...arguments);
    this.headline = "";
    this.maxLines = 3;
  }
  _renderPreview() {
    if (this.thumbnail) {
      return ke`<jb-thumbnail
        .backgroundPicture="${this.thumbnail.backgroundPicture}"
        .videoSrc="${this.thumbnail.videoSrc}"
        .aspect="${this.thumbnail.aspect}"
        .type="${this.thumbnail.type}"
      ></jb-thumbnail>`;
    }
    if (this.picture) {
      return ke`<jb-picture
        .alt=${this.picture.alt}
        .fit=${"cover"}
        .imgData=${this.picture.imgData}
        .lazy=${this.picture.lazy}
        .aspect=${this.gallery ? this.picture.aspect : "aspect_3by2"}
      ></jb-picture>`;
    }
    return null;
  }
  _renderTeaser() {
    if (this.teaser) {
      return ke`<p class="teaser-text-${this.maxLines}-lines">${this.teaser}</p>`;
    }
    return null;
  }
  render() {
    return ke`<header class="${Rt({ no_image: !this.thumbnail && !this.picture, gallery: !!this.gallery })}">
      ${this._renderPreview()} ${this.headline ? ke`<h3>${this.headline}</h3>` : D}
      ${this.teaser ? this._renderTeaser() : D}
    </header>`;
  }
};
JbTeaserHeader.styles = [reset_css_default, jb_teaser_header_css_default];
__decorateClass([
  n({ type: Boolean })
], JbTeaserHeader.prototype, "gallery", 2);
__decorateClass([
  n()
], JbTeaserHeader.prototype, "headline", 2);
__decorateClass([
  n({ type: Number })
], JbTeaserHeader.prototype, "maxLines", 2);
__decorateClass([
  n({ type: Object })
], JbTeaserHeader.prototype, "picture", 2);
__decorateClass([
  n()
], JbTeaserHeader.prototype, "teaser", 2);
__decorateClass([
  n({ type: Object })
], JbTeaserHeader.prototype, "thumbnail", 2);
JbTeaserHeader = __decorateClass([
  customElement("jb-teaser-header")
], JbTeaserHeader);

export {
  JbTeaserHeader
};
